// Used to update a single notification, currenty for use with testDriveNotified and creditAppNotified
export default function updateDealReminders(_ref) {
  let {
    types
  } = _ref;
  return function (payload) {
    if (payload === void 0) {
      payload = {};
    }
    return (dispatch, getState) => {
      const allDealDetails = getState()?.payments?.dealDetails;
      const {
        dealId,
        testDriveNotified,
        creditAppNotified,
        testDriveCompleted
      } = payload;
      const updateReminders = deals => Object.keys(deals).reduce((acc, dealXgId) => {
        const dealDetails = allDealDetails[dealXgId];
        const {
          creditApp,
          testDrive
        } = dealDetails;
        if (dealXgId === dealId) {
          const updatedTestDriveNotified = testDriveNotified || testDrive.testDriveNotified;
          const updatedTestDriveCompleted = testDriveCompleted || testDrive.testDriveCompleted;
          const updatedCreditAppNotified = creditAppNotified || creditApp.creditAppNotified;
          acc[dealXgId] = {
            ...dealDetails,
            testDrive: {
              ...testDrive,
              testDriveNotified: updatedTestDriveNotified,
              testDriveCompleted: updatedTestDriveCompleted
            },
            creditApp: {
              ...creditApp,
              creditAppNotified: updatedCreditAppNotified
            }
          };
        }
        return acc;
      }, {});
      const deals = updateReminders(allDealDetails);
      dispatch({
        type: types.SET_DEAL_DETAILS,
        payload: {
          ...deals
        }
      });
    };
  };
}